<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33"><g transform="translate(0 -0.035)"><rect width="33" height="33" transform="translate(0 0.035)" fill="none"/><g transform="translate(1.376 5.506)"><path d="M16.67,13.13a6.4,6.4,0,0,1,3.207,5.327v4.129h5.506V18.457C25.383,15.456,20.469,13.681,16.67,13.13Z" transform="translate(4.899 -0.563)"/><path d="M15.5,15.012A5.506,5.506,0,0,0,15.5,4a5.751,5.751,0,0,0-1.831.33,8.231,8.231,0,0,1,0,10.351A5.751,5.751,0,0,0,15.5,15.012Z" transform="translate(3.77 -4)"/><path d="M10.506,15.012A5.506,5.506,0,1,0,5,9.506,5.5,5.5,0,0,0,10.506,15.012Zm0-8.259A2.753,2.753,0,1,1,7.753,9.506,2.761,2.761,0,0,1,10.506,6.753Z" transform="translate(0.506 -4)"/><path d="M12.012,13C8.337,13,1,14.844,1,18.506v4.129H23.023V18.506C23.023,14.844,15.687,13,12.012,13Zm8.259,6.882H3.753V18.52c.275-.991,4.542-2.767,8.259-2.767S20,17.529,20.271,18.506Z" transform="translate(-1 -0.612)"/></g></g></svg>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
svg {
    fill: currentColor;
}
</style>

<script>
export default {
  name: 'users'
}
</script>
